module.exports = __webpack_public_path__ + "static/img/surveys.b2a3c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/surveys.png
// module id = Xb5F
// module chunks = 0